export default "https://cdn-web.disco.co/slack-auto-connection-566eab9048bd6bb9aafdb53bd9b1b330.png";